import TextLink from "./TextLink";
import textLinkTypography from "./textLinkTypography";

export { TextLink as default, textLinkTypography };
